"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_motion_1 = tslib_1.__importDefault(require("rc-motion"));
var MobilePopupInner = React.forwardRef(function (props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _a = props.mobile, _b = _a === void 0 ? {} : _a, popupClassName = _b.popupClassName, popupStyle = _b.popupStyle, _c = _b.popupMotion, popupMotion = _c === void 0 ? {} : _c, popupRender = _b.popupRender;
    var elementRef = React.useRef();
    // ========================= Refs =========================
    React.useImperativeHandle(ref, function () { return ({
        forceAlign: function () { },
        getElement: function () { return elementRef.current; },
    }); });
    // ======================== Render ========================
    var mergedStyle = tslib_1.__assign({ zIndex: zIndex }, popupStyle);
    var childNode = children;
    // Wrapper when multiple children
    if (React.Children.count(children) > 1) {
        childNode = React.createElement("div", { className: "".concat(prefixCls, "-content") }, children);
    }
    // Mobile support additional render
    if (popupRender) {
        childNode = popupRender(childNode);
    }
    return (React.createElement(rc_motion_1.default, tslib_1.__assign({ visible: visible, ref: elementRef, removeOnLeave: true }, popupMotion), function (_a, motionRef) {
        var motionClassName = _a.className, motionStyle = _a.style;
        var mergedClassName = (0, classnames_1.default)(prefixCls, popupClassName, motionClassName);
        return (React.createElement("div", { ref: motionRef, className: mergedClassName, style: tslib_1.__assign(tslib_1.__assign({}, motionStyle), mergedStyle) }, childNode));
    }));
});
MobilePopupInner.displayName = 'MobilePopupInner';
exports.default = MobilePopupInner;
//# sourceMappingURL=MobilePopupInner.js.map